/**
 * @author hxliu
 * @description 题库题目管理列表
 * @Date 2020/02/03
 */
import { component_tool } from '@/tool';
let { WizModal,WizButton } = component_tool;
import moment from "moment";
import React from "react";
import { BankQuestionLook } from '..';
//配置项
let componentName = 'bankQuestion'

let ref;

const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "题目类型",
    name: "type",
    dataIndex: "type",
    dict: [
      { code: 0, codeName: "单选题" },
      { code: 1, codeName: "多选题" },
      { code: 2, codeName: "判断题" },
      { code: 3, codeName: "填空题" },
      { code: 4, codeName: "主观题" },
      { code: 6, codeName: "文件上传题" },
      { code: 7, codeName: "排序题" },
    ],
    searchItem: {
      type: "select"
    },
  },

  {
    title: "难度",
    name: "difficulty",
    dataIndex: "difficulty",
    dict: [
      { code: 0, codeName: "低" },
      { code: 1, codeName: "中" },
      { code: 2, codeName: "高" }
    ],
    searchItem: {
      type: "select"
    }
  },

  {
    title: "题目内容",
    name: "title",
    dataIndex: "title",
    searchItem: {
    },
  },

  {
    title: "题目编码",
    name: "number",
    dataIndex: "number",
    searchItem: {
    }
  },

  {
    title: "所属分类",
    name: "categoryNames",
    dataIndex: "categoryNames",
    tableItem: {
      width: 150}
  },
  {
    title: "题目类型",
    name: "type",
    dataIndex: "type",
    dict: [
      { code: 0, codeName: "单选题" },
      { code: 1, codeName: "多选题" },
      { code: 2, codeName: "判断题" },
      { code: 3, codeName: "填空题" },
      { code: 4, codeName: "主观题" },
      { code: 6, codeName: "文件上传题" },
      { code: 7, codeName: "排序题" },
    ],
    tableItem: {}
  },
  {
    title: "题目内容",
    name: "title",
    dataIndex: "title",
    tableItem: {
      width: 500,
    },
  },
  {
    title: "题目编码",
    name: "number",
    dataIndex: "number",
    tableItem: {
      width: 150,
    },
  },

  {
    title: "难度",
    name: "difficulty",
    dataIndex: "difficulty",
    dict: [
      { code: 0, codeName: "低" },
      { code: 1, codeName: "中" },
      { code: 2, codeName: "高" }
    ],
    tableItem: {},
  },,
  {
    title: "创建时间",
    name: "createTime",
    dataIndex: "createTime",
    tableItem: {
      width: 200,
      render: (text) => {
        return formatterDate(text)
      }
    },
  },
  {
    title: "修改时间",
    name: "updateTime",
    dataIndex: "updateTime",
    tableItem: {
      width: 200,
      render: (text) => {
        return formatterDate(text)
      }
    },
  },
  {
    title: "关联考试数",
    name: "examCount",
    dataIndex: "examCount",
    tableItem: {
      width: 100,
    },
  },
  {
    title: "题库类型",
    name: "mode",
    dataIndex: "mode",
    dict: [
      { code: 0, codeName: "考试" },
      { code: 1, codeName: "练习" }
    ],
    searchItem: {
      type: "select"
    },
  }
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      //btnAccessCheck:false,
      searchBarProps: {
        buttonSort:['add','delete','batchImport','export'],
        buttons: [
          {
            key: "add",
            custom: true,
            params: { children: "新增", icon: "plus", type: "primary" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: "/online/bankQuestion/bankQuestionAdd"
              }
            }
          },
          {
            key: 'export',
            custom: true,
            params: {  icon: "export", children: "导出", type: "export"
             },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: "export",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                return {...filters}
              }
            }
          },
          {
            key: 'batchImport',
            custom: true,
                params: { icon: 'import', children: '批量导入', type: 'import'},
                customOnClick: {
                  key: 'jumpPage',
                  params: {
                  key: 'push',
                  pathname: '/online/bankQuestion/fileImport',
                }
              },
            }
        ]
      },
      siderBarProps: {
        key: "orgNodeTree",
        searchKey: "id",
        params: {}
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },

      rowOperateSort:['look','update'],
      rowOperateView: [

        {
          key: "look",
          custom: true,
          params: {children: "查看"},
          customOnClick: {
            key: "modal",
            params: {
              modalParams: {
                cancelButtonProps:{ style: { height: 0, width: 0 } },
                style:{ minWidth: 700 },
                //onOk: () => {ref._ok();},
                //onCancel: () => {},
                footer:null,
                title: "题目查看",
                diy: (e) => {
                 // let record = {id:106914,type:1}
                  return(
                  <BankQuestionLook key = {e.record.id}
                    //  record={record}
                    //key={new Date()}
                    {...e}
                    ref={r => {
                      ref = r && r.getWrappedInstance();
                    }}
                  />
                )},

              onOk: () => {ref._onOk()},
                width: 950
              }

            }
          }
        },
        {
          key: "update",
          custom: true,
          params: {children: "编辑"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/online/bankQuestion/bankQuestionUpd"
            }
          }
        },

      ]
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/normalListByPage`,
    payload: {
      key: `${componentName}@normalListByPage`,
      apiParams: { pageNum: 1, pageSize: 10 }
    }
  },
  export: {
    path: `${componentName}/export`,
    payload: {
      key: `${componentName}@export`,
      apiParams: {}
    }
  },
  treeData: {
    path: `questionType/normalNodeList`,
    payload: {
      key: `questionType@treeData`,
      apiParams: {type:2}
    }
  },
  delete: {
    path: `${componentName}/delete`,
    payload: {
      key: `${componentName}@delete`,
      apiParams: {}
    }
  },
}


let reduxTemplateCofig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list',  'treeData'],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
